import { getPromiseState } from '@warp-drive/ember';

export default function isPending(promise) {
  return promise && getPromiseState(promise).isPending;
}
